import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { API_BASE_URL, Image_URL } from "../config";

const StockcarryDetail = () => {
  const { orderId, orderItemId } = useParams();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [editComment, setEditComment] = useState("");
  const [editOrderRef, setEditOrderRef] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [errors, setErrors] = useState({});
  const [forceUpdate, setForceUpdate] = useState(0);

  const fetchOrderDetails = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/Order/GetOrdersdetails?OrderId=${orderId}&OrderItemId=${orderItemId}`
      );
      if (!response.ok) throw new Error("Failed to fetch order details.");
      const data = await response.json();
      setOrders(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [orderId, orderItemId, forceUpdate]);

  const applyMarkup = (base) => {
    const view = localStorage.getItem("activeView") || "wholesale";
    if (view === "wholesale") return base;

    const storedPayload = JSON.parse(localStorage.getItem("priceTable_seller") || "{}");
    const table = Array.isArray(storedPayload.data) ? storedPayload.data : [];

    if (!table.length) return base;

    const range = table.find(r => {
      const from = parseFloat(r.from || 0);
      const to = r.to === null ? Infinity : parseFloat(r.to);
      return base >= from && base <= to;
    });

    if (!range) return base;

    const markupPercent = parseFloat(range.markup || 0);
    return base * markupPercent;
  };

  useEffect(() => {
    const update = () => setForceUpdate((p) => p + 1);

    window.addEventListener("storage", update);
    window.addEventListener("activeViewChanged", update);
    window.addEventListener("markupTableChanged", update);

    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener("activeViewChanged", update);
      window.removeEventListener("markupTableChanged", update);
    };
  }, []);


  const openImagePopup = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImagePopup(true);
  };

  const closeImagePopup = () => {
    setSelectedImage(null);
    setShowImagePopup(false);
  };

  const openEditPopup = (itemId) => {
    setSelectedItemId(itemId);
    setEditComment("");
    setEditOrderRef("");
    setErrors({});
    setShowEditPopup(true);
  };


  const validateFields = () => {
    let tempErrors = {};

    if (!editComment.trim()) {
      tempErrors.comment = "Comment is required.";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const saveCommentUpdate = async () => {
    if (!validateFields()) return;

    try {
      const response = await fetch(
        `${API_BASE_URL}/Order/UpdateOrderItemDetails`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            orderItemID: selectedItemId,
            comments: editComment,
            orderRef: editOrderRef,
          }),
        }
      );

      const result = await response.json();

      if (!result.status) {
        alert("Failed to update item.");
        return;
      }

      alert("Item updated successfully!");
      setShowEditPopup(false);
      fetchOrderDetails(); // Refresh
    } catch (err) {
      alert(err.message);
    }
  };
  if (loading) return <p>Loading order details...</p>;
  if (error) return <p>{error}</p>;
  if (!orders.length) return <p>No order details available.</p>;

  const order = orders[0];
  const groupedItems = order.orderTrackList || [];
  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d)) return "-";
    return d.toLocaleDateString();
  };
  return (
    <>
      <div className="home">
        <Header />

        <div className="section-padding">
          <div className="section-container p-l-r">
            <h2 className="text-center">
              <Link to="/stockcarryorder" style={{ color: "black" }} className="btn btn-view">
                <i className="fa fa-arrow-left" aria-hidden="true"></i>
              </Link>{" "}
            Stock&Carry  Order Details
            </h2>

            {/* Order Summary */}


            {groupedItems.length > 0 ? (
              groupedItems.map((product, index) => (
                <div key={index}>
                  <div className="order-info-container">
                    {/* ORDER INFO – rendered once for each product group */}
                  <div
  className="info-above"
  style={{
    backgroundColor:
      product.updatedBy === "Admin"
        ? "#aed0f4"    
        : product.updatedBy === "Customer"
        ? "#ffb13e"  
        : "transparent" 
  }}
>
                      <div className="order-id">
                        <p>Order Id</p>
                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                          {order.orderID} - {product.productCode}
                        </p>
                      </div>

                      <div className="placed">
                        <p>Order Date</p>
                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                          {new Date(order.orderDate).toLocaleDateString()}
                        </p>
                      </div>
                      <div className="placed">
                        <p>Product Code</p>
                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                          {product.productName}
                        </p>
                      </div>
                      
                      <div className="order-total">
                        <p>Metal</p>
                        <p style={{ fontWeight: "bold" }}>{product.metalName}</p>
                      </div>
                      <div className="placed">
                        <p>Engrave</p>
                        <p style={{ fontWeight: "bold" }}>{product.engrave || "-"}</p>
                      </div>

                      <div className="placed">
                        <p>Carat</p>
                        <p style={{ fontWeight: "bold" }}>{product.carat}</p>
                      </div>

                     
                      <div className="placed">
                        <p>Colour</p>
                        <p style={{ fontWeight: "bold" }}>{product.colour}</p>
                      </div>

                      <div className="placed">
                        <p>Clarity</p>
                        <p style={{ fontWeight: "bold" }}>{product.clarity}</p>
                      </div>
                      <div className="placedby">
                        <p>Quantity</p>
                        <p style={{ fontWeight: "bold" }}>{product.quantity}</p>
                      </div>
                      <div className="order-total">
                        <p>Total Amount</p>
                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                          {order.orderTrackList[0].currency}{" "}
                          {Math.round(applyMarkup(order.totalAmount))}

                        </p>
                      </div>
                    </div>
                    <hr />
                    {/* PRODUCT DETAILS */}
                    <div className="info-below">
                      <div className="img-and-info">

                        <div>
                          <img
                            src={product.productImage || `${Image_URL}/placeholder.png`}
                            alt={product.productName}
                            onClick={() => openImagePopup(product.productImage)}
                            style={{ cursor: "pointer", width: "150px" }}
                          />

                          <div className="delivery-status">
                            <h4>Delivery Status</h4>
                            <h6
                              className={
                                product.statusName === "Delivered"
                                  ? "delivered"
                                  : "transit"
                              }
                            >
                              {product.statusName}
                            </h6>
                          </div>
                        </div>

                        <div className="order-status-content">

                          <p>Status Updated On: <strong>{formatDate(product.statusUpdatedOn)}</strong>
                          </p>


                          <p>
                            Order Comments:{" "}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: product.comments || "No comments",
                              }}
                            />
                          </p>

                          <p>
                            Order Reference:{" "}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: product.orderRef || "No Reference",
                              }}
                            />
                          </p>



                          <div className="info-above">

                            <div className="placed">
                              <p>Updated By</p>
                              <p style={{ fontWeight: "bold" }}>
                                {product.updatedBy || "-"}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Admin Comment</p>
                              <p style={{ fontWeight: "bold" }}>
                                {product.adminComment || "-"}
                              </p>
                            </div>

{/* 
                            <div className="placed">
                              <p>Price</p>
                              <p style={{ fontWeight: "bold" }}>
                                {product.currency} {Math.round(applyMarkup(product.productPrice))}
                              </p>
                            </div> */}





                            {/* NEW FIELDS */}
                            <div className="placed">
                              <p>Approx Delivery Date</p>
                              <p style={{ fontWeight: "bold" }}>
                                {formatDate(product.approxDeliveryDate)}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Dispatch Through</p>
                              <p style={{ fontWeight: "bold" }}>
                                {product.dispatchThrough || "-"}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Dispatch Date</p>
                              <p style={{ fontWeight: "bold" }}>
                                {formatDate(product.dispatchDate)}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Tracking ID</p>
                              <p style={{ fontWeight: "bold" }}>
                                {product.orderTrackingID || "-"}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Delivery Date</p>
                              <p style={{ fontWeight: "bold" }}>
                                {formatDate(product.deliveryDate)}
                              </p>
                            </div>

                            <button
                              className="btn btn-warning"
                              onClick={() => openEditPopup(product.orderItemID)}
                            >
                              Edit
                            </button>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No products in this order.</p>
            )}




          </div>
        </div>
        {/* Product Image Popup */}
        {showImagePopup && selectedImage && (
          <div className="popup-overlay">
            <div className="popup-content">
              <button onClick={closeImagePopup}>Close</button>
              <img src={selectedImage} alt="Expanded Product" style={{ width: "900px" }} />
            </div>
          </div>
        )}

        {showEditPopup && (
          <div className="popup-overlay">
            <div className="popup-content" style={{ width: "450px" }}>
              <h3>Edit Item Details</h3>

              {/* COMMENT */}
              <label>Comment *</label>
              <textarea
                value={editComment}
                onChange={(e) => {
                  setEditComment(e.target.value);
                  setErrors({ ...errors, comment: "" });
                }}
                style={{ width: "100%", height: "90px", marginBottom: "5px" }}
              />
              {errors.comment && (
                <p style={{ color: "red", fontSize: "13px" }}>{errors.comment}</p>
              )}

              {/* ORDER REFERENCE */}
              <label>Order Reference *</label>
              <input
                type="text"
                className="form-control"
                value={editOrderRef}
                onChange={(e) => {
                  setEditOrderRef(e.target.value);
                  setErrors({ ...errors, orderRef: "" });
                }}
                style={{ marginBottom: "5px" }}
              />
              {errors.orderRef && (
                <p style={{ color: "red", fontSize: "13px" }}>{errors.orderRef}</p>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "15px",
                }}
              >
                <button className="btn btn-secondary" onClick={() => setShowEditPopup(false)}>
                  Cancel
                </button>

                <button className="btn btn-success" onClick={saveCommentUpdate}>
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
        <Footer />
      </div>
    </>
  );
};

export default StockcarryDetail;
